import { useEntries } from '../hooks/useEntries';
import { useAuth } from '../firebase/useAuth';
import EntryCard from '../components/EntryCard';
import styles from './JournalScreen.module.css';

export default function JournalScreen() {
  const { entries, loading } = useEntries();
  const { user } = useAuth();

  if (loading) return (
    <div className={styles.container}>
      <div className={styles.loading}>Loading…</div>
    </div>
  );

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h2 className={styles.heading}>Journal</h2>
        <p className={styles.count}>{entries.length} {entries.length === 1 ? 'entry' : 'entries'}</p>
      </header>
      {entries.length === 0 ? (
        <div className={styles.empty}>
          <p>No entries yet.</p>
          <p className={styles.emptySub}>Complete today's prompts to get started.</p>
        </div>
      ) : (
        <div className={styles.list}>
          {entries.map(entry => (
            <EntryCard
              key={entry.id}
              entry={entry}
              authorName={user?.displayName}
              ownerUserId={user?.uid}
            />
          ))}
        </div>
      )}
    </div>
  );
}
